import Unauthorized from "screens/public/unauthorized";
export default Unauthorized;
